"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Close = function (_a) {
    var width = _a.width, height = _a.height, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9091 11.8182L28.1818 9.09094L20 17.2728L11.8182 9.09094L9.09088 11.8182L17.2727 20L9.09088 28.1819L11.8182 30.9091L20 22.7273L28.1818 30.9091L30.9091 28.1819L22.7272 20L30.9091 11.8182Z", fill: fill })));
};
Close.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Close.defaultProps = {
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Close;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xvc2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaWNvbnMvQ2xvc2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNkJBQStCO0FBQy9CLHNDQUF3QztBQUV4QyxvQ0FBZ0M7QUFPaEMsSUFBTSxLQUFLLEdBQXlCLFVBQUMsRUFBcUI7UUFBcEIsZ0JBQUssRUFBRSxrQkFBTSxFQUFFLGNBQUk7SUFDdkQsT0FBTyxDQUNMLDZCQUFLLEtBQUssRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUMsV0FBVyxFQUFDLElBQUksRUFBQyxNQUFNO1FBQ2hFLDhCQUNFLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLENBQUMsRUFBQywrTEFBK0wsRUFDak0sSUFBSSxFQUFFLElBQUksR0FDVixDQUNFLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLEtBQUssQ0FBQyxTQUFTLEdBQUc7SUFDaEIsS0FBSyxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN2RSxNQUFNLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFRO0lBQ3hFLElBQUksRUFBRSxTQUFTLENBQUMsTUFBTTtDQUN2QixDQUFDO0FBRUYsS0FBSyxDQUFDLFlBQVksR0FBRztJQUNuQixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsS0FBSyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Close.js
// module id = 60
// module chunks = 0